/**
 * @fileoverview Italian translations.
 * @package PlayItNow
 * @module apps/front/lib/i18n/locales/it
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */

export const it = {
  login: {
    title: 'PlayItNow',
    subtitle: 'Accedi al tuo spazio amministratore',
    emailLabel: 'Email o nome utente',
    emailPlaceholder: 'tua@email.com o nome utente',
    passwordLabel: 'Password',
    passwordPlaceholder: '••••••••',
    submitButton: 'Accedi',
    submitting: 'Accesso in corso...',
    forgotPassword: 'Password dimenticata?',
    noAdminRights: 'Non hai i diritti di amministratore',
    errorGeneric: 'Si è verificato un errore durante l\'accesso',
    showPassword: 'Mostra password',
    hidePassword: 'Nascondi password',
  },
  auth: {
    optional: 'opzionale',
  },
  home: {
    title: 'Vota le tue canzoni preferite ai concerti dal vivo!',
    wantToVote: 'Voglio votare',
    wantToVoteDescription: 'Crea un account gratuito per votare ai concerti',
    wantToManageBand: 'Gestisco la mia band',
    wantToManageBandDescription: 'Crea un account per gestire eventi e brani',
    alreadyHaveAccount: 'Hai già un account?',
  },
  landing: {
    languageLabel: 'Scegli la lingua',
    heroTitle: 'Lascia che il pubblico scelga il prossimo brano della tua setlist',
    heroSubtitle:
      'Crea la tua setlist. I fan scansionano un QR code e votano il prossimo brano in tempo reale. Un\'esperienza unica ad ogni concerto.',
    ctaPrimary: 'Crea il mio account band — prova gratuita',
    whyTitle: 'Perché PlayItNow?',
    benefit1Title: 'Un QR code, il pubblico vota',
    benefit1Desc: 'Il tuo pubblico scansiona e vota le canzoni preferite dal cellulare. Più interattività.',
    benefit2Title: 'Classifica in diretta',
    benefit2Desc: 'I voti si aggiornano in tempo reale. Suoni i brani più richiesti sul palco.',
    benefit3Title: 'Semplice per le band',
    benefit3Desc: 'Crea eventi, gestisci la setlist, avvia il voto con un clic. Prezzi per artisti.',
    twoWaysTitle: 'Due modi per vivere PlayItNow',
    ctaBand: 'Sono una band',
    ctaBandDesc: 'Crea eventi, aggiungi i tuoi brani, lascia che il pubblico voti dal vivo.',
    ctaFan: 'Sono uno spettatore',
    ctaFanDesc: 'Unisciti a un concerto tramite QR code e vota i brani che vuoi sentire.',
    alreadyAccount: 'Hai già un account?',
    login: 'Accedi',
    learnMore: 'Vedi eventi',
  },
  public: {
    login: {
      title: 'PlayItNow',
      subtitle: 'Vota le tue canzoni preferite!',
      subtitle2: 'I brani più votati saranno suonati dal vivo!',
      identifyTitle: 'Identificati',
      identifySubtitle: 'Vota per scegliere il prossimo brano del concerto!',
      emailLabel: 'Email o nome utente',
      emailPlaceholder: 'tua@email.com o nome utente',
      passwordLabel: 'Password',
      passwordPlaceholder: '••••••••',
      submitButton: 'Accedi',
      submitting: 'Accesso in corso...',
      loading: 'Caricamento...',
      withoutRegistration: 'Accedi al voto',
      or: 'OPPURE',
      errorGeneric: 'Si è verificato un errore',
      showPassword: 'Mostra password',
      hidePassword: 'Nascondi password',
      firstNameLabel: 'Il tuo nome (opzionale)',
      firstNamePlaceholder: 'Mario',
      firstNameHint: 'Il tuo nome sarà mostrato quando voti',
      haveAccount: 'Ho un account',
      forgotPassword: 'Password dimenticata?',
      createAccount: 'Crea un account (gratuito)',
      pinDataHub: 'Gestisco la mia band',
      orDivider: 'oppure',
      loginWithGoogle: 'Accedi con Google',
      loginWithFacebook: 'Accedi con Facebook',
      oauthNoAccount: 'Nessun account associato a questo profilo. Scegli « Account fan » o « Account gruppo » nella home e continua con Google o Facebook.',
      oauthFailed: 'Accesso con questo provider non riuscito. Riprova.',
      oauthNoEmail: 'Facebook non ha fornito un indirizzo email. Verifica i permessi o registrati con Google.',
      oauthUnavailable: 'Accesso con questo provider temporaneamente non disponibile.',
      oauthUseProvider: 'Accedi con Google o Facebook.',
      oauthCompleteEmailTitle: 'Facebook non ha condiviso la tua email',
      oauthCompleteEmailDescription: 'Inserisci il tuo indirizzo email per completare l’accesso.',
      oauthCompleteEmailSubmit: 'Completa accesso',
      oauthCompleteEmailPlaceholder: 'tua@email.com',
      oauthCompleteEmailExpired: 'Sessione scaduta. Riprova con Facebook.',
      oauthCompleteEmailNoAccount: 'Scegli prima un tipo di account (fan o gruppo) dalla home.',
    },
    register: {
      title: 'Crea un account',
      subtitle: 'Unisciti alla community PlayItNow',
      firstNameLabel: 'Nome',
      firstNamePlaceholder: 'Mario',
      lastNameLabel: 'Cognome',
      lastNamePlaceholder: 'Rossi',
      emailLabel: 'Email',
      emailPlaceholder: 'tua@email.com',
      usernameLabel: 'Nome utente',
      usernamePlaceholder: 'mario.rossi',
      autoGenerated: 'Generato automaticamente',
      usernameHint: 'Puoi modificare questo nome utente',
      submitButton: 'Crea il mio account',
      submitting: 'Creazione account...',
      backToLogin: 'Torna al login',
      orDivider: 'oppure',
      continueWithGoogle: 'Continua con Google',
      continueWithFacebook: 'Continua con Facebook',
      successTitle: 'Registrazione completata!',
      successMessage:
        'È stata inviata un\'email di conferma. Controlla la posta per attivare il tuo account.',
      error: {
        firstNameRequired: 'Il nome è obbligatorio',
        lastNameRequired: 'Il cognome è obbligatorio',
        emailRequired: 'L\'email è obbligatoria',
        generic: 'Si è verificato un errore durante la creazione dell\'account',
      },
      bandNameLabel: 'Nome della band',
      bandNamePlaceholder: 'Nome della tua band',
      passwordLabel: 'Password',
      passwordPlaceholder: '••••••••',
      passwordMinLength: 'La password deve contenere almeno 8 caratteri',
      logoUrlLabel: 'URL del logo (opzionale)',
      logoUrlPlaceholder: 'https://example.com/logo.png',
      showPassword: 'Mostra password',
      hidePassword: 'Nascondi password',
    },
    events: {
      title: 'Prossimi eventi',
      noEvents: 'Nessun evento in programma',
      noEventsDescription: 'Non ci sono eventi nei prossimi 2 giorni.',
      errorLoad: 'Errore nel caricamento degli eventi',
      settings: 'Impostazioni',
      logout: 'Esci',
    },
    event: {
      invalidSlug: 'Slug evento non valido',
      notFound: 'Evento non trovato',
      errorLoad: 'Errore nel caricamento dell\'evento',
      backToEvents: 'Torna agli eventi',
      songsTitle: 'Brani disponibili',
      noSongs: 'Nessun brano disponibile al momento',
      vote: 'Vota',
      voted: 'Votato',
      loading: 'Caricamento...',
      votesRemaining: 'Voti rimanenti',
      voteSuccess: 'Il tuo voto è stato registrato!',
      voteError: 'Errore nella registrazione del voto',
      totalVotes: 'Voti totali',
      votesLabel: 'voti',
      blindVoteMessage: 'La classifica sarà rivelata dalla band.',
      rankingTitle: 'Classifica',
      votingPaused: 'Le votazioni sono attualmente sospese.',
      votingCompleted: 'Questo evento è terminato. Le votazioni sono chiuse.',
      settings: 'Impostazioni',
      logout: 'Esci',
    },
    qrCode: {
      title: 'Condividi questo evento',
      description: 'Scansiona questo QR code o condividi il link per invitare altri a votare',
      share: 'Condividi',
      copy: 'Copia link',
      show: 'Mostra QR code',
      shareText: 'Vota con me i brani di {{eventName}}!',
    },
    settings: {
      title: 'Impostazioni account',
      account: 'Account',
      email: 'Email',
      username: 'Nome utente',
      firstName: 'Nome',
      lastName: 'Cognome',
      save: 'Salva',
      saving: 'Salvataggio...',
      success: 'Impostazioni salvate con successo',
      error: 'Errore nel salvataggio',
      password: {
        title: 'Cambia password',
        currentPassword: 'Password attuale',
        currentPasswordPlaceholder: '••••••••',
        newPassword: 'Nuova password',
        newPasswordPlaceholder: '••••••••',
        confirmPassword: 'Conferma nuova password',
        confirmPasswordPlaceholder: '••••••••',
        change: 'Cambia password',
        changing: 'Modifica in corso...',
        success: 'Password modificata. Effettua di nuovo l\'accesso.',
        error: 'Errore nel cambio password',
        mismatch: 'Le password non coincidono',
        incorrect: 'La password attuale non è corretta',
      },
      deleteAccount: {
        title: 'Elimina account',
        description: 'L\'eliminazione del tuo account è definitiva e irreversibile.',
        button: 'Elimina il mio account',
        confirming: 'Conferma...',
        confirmTitle: 'Conferma eliminazione',
        confirmMessage:
          'Sei sicuro di voler eliminare il tuo account? Questa azione è irreversibile.',
        confirmButton: 'Sì, elimina',
        cancelButton: 'Annulla',
        success: 'Account eliminato con successo',
        error: 'Errore nell\'eliminazione dell\'account',
      },
    },
    dataExport: {
      title: 'Esporta i tuoi dati',
      description:
        'In conformità con il GDPR, puoi richiedere l\'esportazione di tutti i tuoi dati personali memorizzati su PlayItNow.',
      whatIncluded: 'L\'esportazione includerà:',
      included: {
        profile: 'Le tue informazioni di profilo (email, nome, ecc.)',
        votes: 'La cronologia dei tuoi voti',
        preferences: 'Le tue preferenze (tema, lingua)',
        sessions: 'Le tue sessioni di accesso',
      },
      exportButton: 'Esporta i miei dati',
      exporting: 'Esportazione in corso...',
      success: 'I tuoi dati sono stati esportati. Il download inizierà a breve.',
      error: 'Si è verificato un errore durante l\'esportazione dei dati.',
      note: 'Nota: l\'esportazione può richiedere qualche istante. Il file sarà in formato JSON.',
    },
  },
  legal: {
    title: 'Note legali',
    editor: {
      title: 'Editore',
      name: 'axialdata',
      email: 'Email: contact@axialdata.net',
      siret: 'SIRET: 49347625300023',
    },
    publication: {
      title: 'Direttore della pubblicazione',
      director: 'Pierre-Yves Léglise',
    },
    hosting: {
      title: 'Hosting',
      name: 'Hostinger International Ltd',
      addressLine1: 'L\'applicazione è ospitata in Francia (data center Parigi).',
      addressLine2: 'Sede legale: Švitrigailos g. 34, LT-03230 Vilnius, Lituania',
      country: 'Lituania',
      url: 'https://www.hostinger.com',
    },
    dataProtection: {
      title: 'Protezione dei dati',
      description:
        'In conformità con il Regolamento generale sulla protezione dei dati (GDPR), hai diritti riguardo ai tuoi dati personali.',
      link: 'Consulta la nostra privacy policy',
    },
  },
  privacy: {
    title: 'Privacy policy',
    lastUpdated: 'Ultimo aggiornamento: ottobre 2025',
    intro: {
      title: 'Introduzione',
      description:
        'PlayItNow si impegna a proteggere la tua privacy e i tuoi dati personali. Questa policy spiega come raccogliamo, utilizziamo e proteggiamo le tue informazioni.',
    },
    dataCollection: {
      title: 'Dati raccolti',
      bands: {
        title: 'Per le band (clienti paganti)',
        email: 'Indirizzo email',
        username: 'Nome utente',
        name: 'Nome della band e informazioni di contatto',
        payment: 'Informazioni di pagamento (tramite fornitore terzo sicuro)',
        logo: 'Logo della band',
      },
      spectators: {
        title: 'Per gli spettatori (utenti gratuiti)',
        email: 'Indirizzo email (in caso di creazione account)',
        firstName: 'Nome (opzionale, per visualizzazione durante i voti)',
        fingerprint: 'Impronta digitale del browser (anti-frode)',
        ip: 'Indirizzo IP (per sicurezza e audit)',
        votes: 'Cronologia dei voti',
      },
    },
    purposes: {
      title: 'Finalità del trattamento',
      authentication: 'Autenticazione e gestione degli account',
      voting: 'Gestione del sistema di voto interattivo',
      fraud: 'Prevenzione frodi e sicurezza dei voti',
      billing: 'Fatturazione e gestione abbonamenti (solo band)',
      support: 'Supporto clienti e assistenza tecnica',
      preferences: 'Memorizzazione preferenze (tema, lingua)',
      analytics: 'Misurazione audience del sito (Rybbit self-hosted, uso interno: pagine viste, provenienza; nessun dato venduto o ceduto)',
    },
    legalBasis: {
      title: 'Base giuridica',
      description:
        'Il trattamento dei tuoi dati si basa su: (1) esecuzione del contratto per le band, (2) tuo consenso per gli spettatori, (3) nostro legittimo interesse per sicurezza e prevenzione frodi.',
    },
    retention: {
      title: 'Conservazione dei dati',
      active: 'Dati account attivo: conservati per tutta la durata d\'uso del servizio',
      inactive: 'Dati account inattivo: eliminati dopo 3 anni di inattività',
      legal: 'Dati richiesti da obblighi legali: conservati secondo i termini di legge applicabili',
    },
    rights: {
      title: 'I tuoi diritti',
      description: 'In conformità con il GDPR hai i seguenti diritti:',
      access: 'Diritto di accesso: consultare i tuoi dati personali',
      rectification: 'Diritto di rettifica: correggere dati inesatti',
      deletion: 'Diritto alla cancellazione: eliminare i tuoi dati (diritto all\'oblio)',
      portability: 'Diritto alla portabilità: ricevere i tuoi dati in formato strutturato',
      opposition: 'Diritto di opposizione: opporti al trattamento dei tuoi dati',
      limitation: 'Diritto di limitazione: limitare il trattamento dei tuoi dati',
      contact:
        'Per esercitare i tuoi diritti, contattaci a: contact@axialdata.net. Puoi anche esportare o eliminare i tuoi dati dalle Impostazioni account.',
    },
    security: {
      title: 'Sicurezza dei dati',
      description:
        'Adottiamo misure tecniche e organizzative adeguate per proteggere i tuoi dati da accessi non autorizzati, perdita, distruzione o alterazione. I dati sono memorizzati su server sicuri e le comunicazioni sono criptate.',
    },
    cookies: {
      title: 'Cookie e tracker',
      description:
        'La nostra applicazione utilizza cookie essenziali per il funzionamento del servizio. Per maggiori informazioni, consulta la nostra cookie policy.',
      link: 'Cookie policy',
    },
    contact: {
      title: 'Contatto',
      description: 'Per qualsiasi domanda su questa policy o i tuoi dati personali:',
      email: 'contact@axialdata.net',
    },
  },
  cookies: {
    title: 'Cookie policy',
    intro: {
      title: 'Introduzione',
      description:
        'Questa pagina ti informa sull\'uso di cookie e tecnologie simili su PlayItNow.',
    },
    essential: {
      title: 'Cookie essenziali',
      description:
        'I seguenti cookie sono strettamente necessari al funzionamento del servizio e non richiedono consenso preventivo:',
      accessToken: {
        title: 'access_token',
        description:
          'Cookie di autenticazione che mantiene la sessione. Questo cookie è httpOnly (non accessibile via JavaScript) e sicuro.',
        duration: 'Durata: 15 minuti',
      },
      refreshToken: {
        title: 'refresh_token',
        description:
          'Cookie che rinnova automaticamente la sessione. Questo cookie è httpOnly e sicuro.',
        duration: 'Durata: 7 giorni',
      },
      csrfToken: {
        title: 'csrf_token',
        description:
          'Cookie di protezione CSRF. Accessibile via JavaScript per validazione lato client.',
        duration: 'Durata: 7 giorni',
      },
    },
    localStorage: {
      title: 'Archiviazione locale (localStorage)',
      description: 'Utilizziamo anche l\'archiviazione locale del browser per memorizzare le tue preferenze:',
      theme: 'Tema di visualizzazione (chiaro/scuro)',
      lang: 'Lingua preferita',
      firstname: 'Nome (per visualizzazione durante i voti)',
      fingerprint: 'Impronta digitale del browser (anti-frode)',
    },
    analytics: {
      title: 'Misurazione audience (Rybbit)',
      description:
        'Quando la misurazione audience è attiva (produzione), uno script Rybbit, ospitato sui nostri server (analytics.axialdata.app), invia dati minimali (pagine viste, provenienza) per analizzare l\'uso del sito, solo a uso interno. Niente pubblicità; nessun dato venduto o ceduto. Il trattamento si basa sul nostro legittimo interesse. Rybbit può usare un identificatore tecnico (cookie o localStorage) per deduplicare le visite. Puoi bloccare gli script di terze parti nel browser per disattivare questo tracciamento.',
    },
    management: {
      title: 'Gestione cookie',
      description:
        'Puoi gestire i cookie dalle impostazioni del browser. La disattivazione dei cookie essenziali può impedire il corretto funzionamento dell\'applicazione.',
    },
  },
  terms: {
    title: 'Condizioni generali d\'uso',
    lastUpdated: 'Ultimo aggiornamento: ottobre 2025',
    intro: {
      title: 'Articolo 1 - Oggetto',
      description:
        'Le presenti Condizioni generali d\'uso (CGU) regolano l\'utilizzo del servizio PlayItNow, una piattaforma SaaS che consente alle band musicali di offrire un\'esperienza interattiva al pubblico durante i concerti. Le CGU si applicano sia alle band (clienti paganti) che agli spettatori (utenti gratuiti).',
    },
    service: {
      title: 'Articolo 2 - Descrizione del servizio',
      description:
        'PlayItNow è un\'applicazione web che consente alle band di creare eventi, gestire una libreria di brani e permettere al pubblico di votare i brani che desidera ascoltare. Il servizio è a pagamento per le band e gratuito per gli spettatori.',
    },
    forBands: {
      title: 'Articolo 3 - Condizioni specifiche per le band',
      subtitle: 'Le seguenti condizioni si applicano solo alle band che utilizzano il servizio come clienti paganti:',
      registration: {
        title: '3.1 - Registrazione e account',
        description:
          'Per usare il servizio come band devi creare un account fornendo informazioni accurate e aggiornate. Sei responsabile della riservatezza delle tue credenziali e di tutte le attività effettuate dal tuo account.',
      },
      subscription: {
        title: '3.2 - Abbonamenti e prezzi',
        description:
          'L\'accesso al servizio per le band è soggetto a un abbonamento a pagamento. Prezzi, piani e condizioni sono disponibili sulla piattaforma. Gli abbonamenti si rinnovano automaticamente salvo disdetta.',
      },
      payment: {
        title: '3.3 - Pagamento',
        description:
          'I pagamenti sono effettuati tramite un fornitore di pagamento sicuro. In caso di mancato pagamento, l\'accesso al servizio può essere sospeso. Nessun rimborso in caso di risoluzione anticipata, salvo disposizione di legge.',
      },
      obligations: {
        title: '3.4 - Obblighi',
        customer: {
          title: '3.4.1 - Obblighi del cliente',
          accuracy: 'Fornire informazioni accurate e aggiornate',
          security: 'Mantenere la riservatezza delle credenziali',
          compliance: 'Rispettare leggi e regolamenti applicabili',
          prohibited: 'Non usare il servizio per scopi illegali o fraudolenti',
        },
        provider: {
          title: '3.4.2 - Obblighi del fornitore',
          availability: 'Garantire la disponibilità del servizio nella misura del possibile',
          support: 'Fornire supporto tecnico nei limiti del servizio',
          security: 'Implementare misure di sicurezza adeguate',
        },
      },
      intellectualProperty: {
        title: '3.5 - Proprietà intellettuale',
        description:
          'Tutti gli elementi del servizio PlayItNow (codice, design, marchi, ecc.) sono di esclusiva proprietà di axialdata. L\'uso del servizio non conferisce alcun diritto di proprietà su tali elementi.',
      },
      termination: {
        title: '3.6 - Risoluzione',
        description:
          'Puoi cancellare il tuo abbonamento in qualsiasi momento dall\'area clienti. axialdata si riserva il diritto di sospendere o risolvere qualsiasi account in caso di inosservanza delle presenti CGU.',
      },
      jurisdiction: {
        title: '3.7 - Legge applicabile e foro',
        description:
          'Le presenti CGU sono regolate dalla legge francese. In caso di controversia, i tribunali francesi sono competenti in via esclusiva.',
      },
    },
    forSpectators: {
      title: 'Articolo 4 - Condizioni specifiche per gli spettatori',
      subtitle: 'Le seguenti condizioni si applicano solo agli spettatori che usano il servizio gratuitamente:',
      voting: {
        title: '4.1 - Sistema di voto',
        description: 'Partecipando a un evento puoi:',
        rules: {
          one: 'Votare uno o più brani secondo le regole stabilite dalla band',
          fraud: 'Rispettare i limiti di voto per evitare frodi',
          respect: 'Usare il servizio in modo rispettoso e conforme allo scopo',
        },
      },
      account: {
        title: '4.2 - Account utente',
        description:
          'La creazione di un account è facoltativa. Puoi partecipare in modo anonimo indicando solo il nome. Se crei un account, sei responsabile della riservatezza delle tue credenziali.',
      },
      conduct: {
        title: '4.3 - Regole di condotta',
        description: 'È severamente vietato:',
        prohibited: {
          fraud: 'Tentare di frodare il sistema di voto',
          abuse: 'Usare il servizio in modo abusivo o malevolo',
          illegal: 'Usare il servizio per scopi illegali',
        },
      },
      privacy: {
        title: '4.4 - Dati personali',
        description:
          'Il trattamento dei tuoi dati personali è regolato dalla nostra privacy policy. Usando il servizio accetti tale policy.',
        link: 'Consulta la nostra privacy policy',
      },
    },
    liability: {
      title: 'Articolo 5 - Responsabilità',
      description:
        'axialdata non è responsabile per danni diretti o indiretti derivanti dall\'uso o dall\'impossibilità di usare il servizio. Per le band, la responsabilità è limitata all\'importo corrisposto per l\'abbonamento. Per gli spettatori, il servizio è fornito "così com\'è" senza garanzie.',
    },
    modifications: {
      title: 'Articolo 6 - Modifiche',
      description:
        'axialdata si riserva il diritto di modificare le presenti CGU in qualsiasi momento. Le modifiche hanno effetto dalla pubblicazione. L\'uso continuato del servizio costituisce accettazione delle nuove condizioni.',
    },
    contact: {
      title: 'Articolo 7 - Contatto',
      description: 'Per qualsiasi domanda sulle presenti CGU:',
      email: 'contact@axialdata.net',
    },
  },
  cookieBanner: {
    message:
      'Questo sito utilizza cookie essenziali e misurazione audience (anonima, uso strettamente interno). Continuando la navigazione accetti il loro utilizzo.',
    learnMore: 'Maggiori informazioni sui cookie',
    accept: 'Accetto',
  },
  footer: {
    legal: 'Note legali',
    privacy: 'Privacy',
    cookies: 'Cookie',
    terms: 'Termini',
  },
  errors: {
    EVENT_NOT_AVAILABLE_YET:
      'Questo evento non è ancora disponibile. Torna alla data e all\'ora previste per votare.',
    networkError:
      'Impossibile raggiungere il server. Controlla la connessione o riprova più tardi.',
    unexpectedError: 'Si è verificato un errore imprevisto. Riprova più tardi.',
    validationError: 'Dati non validi. Controlla il modulo.',
    badRequest: 'Richiesta non valida.',
    unauthorized: 'Autenticazione richiesta.',
    forbidden: 'Accesso negato.',
    notFound: 'Risorsa non trovata.',
    invalidJsonBody: 'Formato dati non valido.',
    invalidCredentials: 'Credenziali non valide.',
    emailAlreadyRegistered: 'Questo indirizzo email è già registrato.',
    notAuthenticated: 'Devi effettuare l\'accesso.',
    tokenRequired: 'Link non valido o scaduto.',
    ONE_SHOW_DATE_OUT_OF_RANGE:
      "La data dell'evento ONE_SHOW deve essere tra la data di acquisto e +30 giorni",
  },
  common: {
    copyright: 'Tutti i diritti riservati',
    year: new Date().getFullYear().toString(),
    company: 'axialdata',
    required: 'Obbligatorio',
    back: 'Indietro',
    goHome: 'Torna alla home',
    close: 'Chiudi',
    cancel: 'Annulla',
    selectLanguage: 'Seleziona lingua',
    skipToContent: 'Vai al contenuto principale',
    activateDarkMode: 'Attiva modalità scura',
    activateLightMode: 'Attiva modalità chiara',
    loading: 'Caricamento...',
    processing: 'Elaborazione...',
    logoUrlExpiringModalTitle: 'L\'URL dell\'immagine potrebbe scadere',
    logoUrlExpiringModalMessage:
      'Questo URL punta a un host (es. Facebook) i cui link alle immagini possono diventare non validi nel tempo. L\'immagine potrebbe non essere più visualizzata. Puoi comunque salvare questo URL se lo desideri.',
    ok: 'OK',
  },
  pwa: {
    install: {
      button: 'Installa l\'app',
      installButton: 'Installa',
      promptDescription: 'Installa PlayItNow sul tuo dispositivo per un\'esperienza migliore',
      waiting: 'In attesa del permesso di installazione...',
      iosButton: 'Installa su iOS',
      iosTitle: 'Installa PlayItNow su iPhone/iPad',
      iosStep1: '1. Tocca il pulsante condividi in basso sullo schermo',
      iosStep2: '2. Scorri e seleziona "Aggiungi a Home"',
      iosStep3: '3. Tocca "Aggiungi" per installare l\'app',
    },
  },
  forgotPassword: {
    title: 'Password dimenticata',
    subtitle: 'Inserisci la tua email per ricevere un link di reimpostazione',
    emailLabel: 'Indirizzo email',
    emailPlaceholder: 'tua@email.com',
    submitButton: 'Invia link di reimpostazione',
    submitting: 'Invio in corso...',
    successMessage: 'Se esiste un account con questa email, è stato inviato un link per reimpostare la password.',
    backToLogin: 'Torna al login',
    errorGeneric: 'Si è verificato un errore',
  },
  resetPassword: {
    title: 'Reimposta password',
    subtitle: 'Inserisci la nuova password',
    passwordLabel: 'Nuova password',
    passwordPlaceholder: '••••••••',
    confirmPasswordLabel: 'Conferma password',
    confirmPasswordPlaceholder: '••••••••',
    submitButton: 'Reimposta password',
    submitting: 'Reimpostazione...',
    successMessage: 'La password è stata reimpostata. Puoi effettuare l\'accesso.',
    passwordsDoNotMatch: 'Le password non coincidono',
    backToLogin: 'Torna al login',
    errorGeneric: 'Si è verificato un errore durante la reimpostazione',
    invalidToken: 'Il link di reimpostazione non è valido o è scaduto',
  },
  confirmEmail: {
    title: 'Conferma il tuo indirizzo email',
    setPasswordTitle: 'Imposta la tua password',
    setPasswordSubtitle: 'Scegli una password per completare la registrazione.',
    passwordLabel: 'Password',
    confirmPasswordLabel: 'Conferma password',
    submitButton: 'Attiva il mio account',
    confirming: 'Conferma in corso…',
    successFan: 'Account attivato. Reindirizzamento…',
    successBand: 'Account creato. Reindirizzamento…',
    alreadyCompleted: 'Registrazione già completata o link scaduto. Effettua l\'accesso.',
    goToLogin: 'Vai al login',
    invalidToken: 'Link non valido o scaduto. Registrati di nuovo o richiedi una nuova email.',
    missingToken: 'Link di conferma mancante.',
    errorGeneric: 'Si è verificato un errore.',
    backToRegister: 'Torna alla registrazione',
  },
  admin: {
    nav: {
      dashboard: 'Dashboard',
      events: 'Eventi',
      songs: 'Brani',
      venues: 'Locali',
      members: 'Membri',
      settings: 'Impostazioni',
      userSettings: 'Il mio account',
      logout: 'Esci',
    },
    dashboard: {
      welcome: 'Benvenuto',
      bandName: 'Band',
      superadminMode: 'Modalità Super Admin',
      totalEvents: 'Eventi totali',
      activeEvents: 'Eventi attivi',
      upcomingEvents: 'Prossimi eventi',
      quickActions: 'Azioni rapide',
      createEvent: 'Crea evento',
      manageVenues: 'Gestisci locali',
      recentEvents: 'Eventi recenti',
      viewAll: 'Vedi tutti',
      noEvents: 'Nessun evento ancora',
      createFirstEvent: 'Crea il tuo primo evento',
      noVenue: 'Nessun locale',
      errorLoad: 'Errore nel caricamento dei dati',
      status: {
        pending: 'In attesa',
        active: 'Attivo',
        completed: 'Completato',
      },
    },
    planBadge: {
      tooltip: 'Piano attuale — Clicca per gestire l\'abbonamento',
      ariaLabel: 'Visualizza e gestisci il tuo abbonamento',
    },
    oneShowAlert: {
      title: 'Validità evento OneShow',
      daysRemaining: '{{days}} giorno/i rimanente/i',
      daysShort: '{{days}}g',
      daysRemainingMessage: 'Ti restano {{days}} giorno/i per usare questo evento in modalità illimitata.',
      urgentTitle: 'Scadenza imminente',
      expired: 'Evento OneShow scaduto',
      expiredShort: 'Scaduto',
      expiredMessage:
        'Questo evento ha raggiunto la fine della validità. Passa a ProGig per eventi illimitati.',
      upgradeCta: 'Vedi i piani',
    },
    subscription: {
      plan: {
        FREE: 'Gratuito',
        PRO_GIG: 'ProGig',
        LIVE_TOUR: 'LiveTour',
        ONE_SHOW: 'OneShow',
      },
      title: 'Abbonamento',
      subtitle: 'Gestisci il piano della band e i limiti d\'uso',
      currentPlan: 'Piano attuale',
      currentPlanFree: 'Gratuito (FREE)',
      currentPlanProGig: 'ProGig',
      currentPlanLiveTour: 'LiveTour',
      freeDescription: 'Perfetto per scoprire e provare il servizio.',
      proGigDescription: 'Piano per band con più concerti al mese.',
      liveTourDescription: 'Piano per tour intensivi e uso illimitato.',
      chooseProGig: 'Passa a ProGig',
      chooseLiveTour: 'Passa a LiveTour',
      loading: 'Caricamento abbonamento...',
      errorLoad: 'Errore nel caricamento dell\'abbonamento.',
      errorCheckout:
        'Errore nella creazione della sessione di pagamento Stripe. Riprova tra poco.',
      successTitle: 'Pagamento riuscito',
      successMessage: 'Il pagamento è stato elaborato. L\'abbonamento sarà aggiornato a breve.',
      successRedirect: 'Sarai reindirizzato alla dashboard.',
      monthlyQuota: 'Quota mensile',
      freeQuota: 'Quota gratuita',
      eventsUsed: '{{current}} / {{limit}} eventi',
      billingPeriod: 'Periodo: {{start}} - {{end}}',
      quotaReached: 'Quota mensile raggiunta',
      quotaReachedMessage:
        'Hai raggiunto il limite di eventi per questo periodo. La quota si azzererà a fine periodo di fatturazione.',
      quotaWarning: 'Quota mensile quasi raggiunta',
      quotaWarningMessage: 'Ti restano {{remaining}} evento/i per questo periodo.',
      quotaInfo: 'Ti restano {{remaining}} evento/i per questo periodo.',
      upgradePlan: 'Passa al piano superiore',
      upgradeToUnlimited: 'Passa a illimitato',
      upgradeSingleEventConfirm: 'Stai per passare l\'evento "{{eventName}}" a illimitato.',
      singleEventDescription:
        'Pagamento una tantum per voti illimitati per questo evento.',
      oneShowValidity: 'Valido {{days}} giorni dall\'acquisto.',
      oneShowNonRefundable:
        'Pagamento non rimborsabile: una volta effettuato non può essere annullato o rimborsato.',
      multipleProGigSuggestion: 'Più eventi? Il piano ProGig potrebbe essere più conveniente.',
      comparePlans: 'Confronta i piani →',
      upgradeToUnlimitedNow: 'Passa a illimitato ora',
      checkoutError: 'Errore nella creazione della sessione di pagamento. Riprova.',
      oneShowPrice: 'Prezzo',
      oneShowPaymentType: 'Pagamento una tantum',
      oneShowBenefitsTitle: 'Cosa ottieni:',
      oneShowBenefitVotes: 'Voti illimitati per questo evento',
      oneShowBenefitTime: 'Nessun limite di tempo di attivazione',
      chooseOption: 'Scegli un\'opzione',
      convertEvent: 'Converti un evento',
      createEvent: 'Crea evento',
      selectFreeEvent: 'Seleziona un evento gratuito da convertire:',
      convertThisEvent: 'Converti questo evento',
      noFreeEventsToConvert: 'Nessun evento gratuito da convertire. Crea prima un evento.',
      createDescription: 'Crea un nuovo evento con il piano One Show.',
      createNewOneShot: 'Crea evento One Show',
      createOneShotEventTitle: 'Crea evento One Show',
      proceedToPayment: 'Procedi al pagamento',
      oneShowDescription: 'Pagamento una tantum per un evento illimitato.',
      configureOneShot: 'Configura',
      convertEventFromUrl: 'L\'evento "{{name}}" sarà convertito in evento One Show.',
      priceFree: 'Gratuito',
      priceOneTime: '{{price}}€ (pagamento una tantum)',
      pricePerMonth: '{{price}}€ / mese',
      currentPlanBadge: 'Piano attuale',
      selectPlan: 'Scegli',
      planFree: 'Gratuito',
      featureMaxEvents: 'Eventi massimi',
      featureMaxVotes: 'Voti per evento',
      featureActiveTime: 'Tempo di attivazione cumulativo',
      featureEventsPerMonth: 'Eventi al mese',
      featureOneEvent: '1 evento (singolo)',
      featureValidity: 'Validità',
      validityDays: '{{days}} giorni',
      unlimited: 'Illimitato',
      events: 'eventi',
      votes: 'voti',
      minutes: 'min',
      planNote: {
        FREE: 'Max 5 eventi (escluso OneShow). 8 voti per evento. 40 min attivazione cumulativa.',
        ONE_SHOW: 'Pagamento una tantum. Un evento illimitato (voti illimitati, senza limite di tempo).',
        PRO_GIG: '3 eventi al mese (periodo mobile in base alla fatturazione Stripe).',
        LIVE_TOUR: 'Eventi illimitati. Ideale per i tour.',
      },
      cancelSubscriptionButton: 'Annulla abbonamento',
      cancelSubscriptionConfirmTitle: 'Annulla abbonamento',
      cancelSubscriptionConfirmMessage:
        'Nessun rimborso. L\'abbonamento resta attivo fino al {{date}} (fine periodo già pagato), poi torni al piano gratuito. Continuare?',
      cancelSubscriptionSuccess: 'Abbonamento annullato. Conservi l\'accesso fino al {{date}}.',
      cancelSubscriptionError: 'Errore nell\'annullamento dell\'abbonamento.',
      accessUntil: 'Accesso fino al {{date}}',
      cancellationScheduled: 'Annullamento programmato',
      cancelling: 'Annullamento...',
    },
    events: {
      title: 'Eventi',
      subtitle: 'Gestisci concerti e eventi',
      eventsList: 'Elenco eventi',
      upcomingEvents: 'Prossimi eventi',
      pastEvents: 'Eventi passati',
      noEvents: 'Nessun evento ancora',
      addEvent: 'Crea evento',
      add: 'Crea',
      adding: 'Creazione...',
      edit: 'Modifica',
      editing: 'Modifica...',
      cancel: 'Annulla',
      confirm: 'Conferma',
      confirmDeleteTitle: 'Elimina evento',
      confirmDelete: 'Sei sicuro di voler eliminare l\'evento "{{name}}"?',
      name: 'Nome evento',
      namePlaceholder: 'Es: Concerto al Zenith',
      venue: 'Locale',
      selectVenue: 'Seleziona un locale',
      date: 'Data',
      time: 'Ora',
      oneShowDateRestriction: 'Data bloccata: tra acquisto e +{{days}} giorni',
      maxVotesPerUser: 'Voti massimi per utente',
      maxVotes: 'Voti max',
      tiebreaker: 'Parità',
      tiebreakerChronological: 'Cronologico (primo votato)',
      tiebreakerRandom: 'Casuale',
      tiebreakerManual: 'Manuale (scelta del gruppo)',
      showRanking: 'Mostra classifica',
      showRankingToPublic: 'Mostra classifica al pubblico',
      blindVote: 'Voto cieco',
      status: {
        pending: 'In attesa',
        active: 'Attivo',
        completed: 'Completato',
      },
      planBadge: {
        subscription: 'Abbonamento (illimitato)',
        oneShow: 'OneShow (evento illimitato)',
      },
      addSuccess: 'Evento creato con successo',
      addError: 'Errore nella creazione dell\'evento',
      updateSuccess: 'Evento aggiornato con successo',
      updateError: 'Errore nell\'aggiornamento dell\'evento',
      deleteSuccess: 'Evento eliminato con successo',
      deleteError: 'Errore nell\'eliminazione dell\'evento',
      errorLoad: 'Errore nel caricamento degli eventi',
      noVenues: 'Crea almeno un locale prima di creare un evento',
      qrCodeTitle: 'QR Code generato',
      qrCodeDescription: 'Usa questo codice per far votare il pubblico',
      copyQRCode: 'Copia QR code',
      qrCodeCopied: 'QR code copiato negli appunti',
      showQRCode: 'Mostra QR code',
      qrCodePrint: 'Stampa',
      qrCodeShare: 'Condividi',
      qrCodeDownload: 'Scarica',
      qrCodeUrl: 'URL evento',
      qrCodeShareText: 'Vota con me i brani per {{eventName}}!',
      qrCodePrintTitle: 'QR Code - PlayItNow',
      qrCodePrintInstructions:
        'Scansiona questo QR code per accedere all\'evento e votare i tuoi brani preferiti. I brani più votati saranno suonati dal vivo!',
      delete: 'Elimina',
      activate: 'Attiva',
      deactivate: 'Disattiva',
      complete: 'Completa',
      reactivate: 'Riattiva',
      activateSuccess: 'Evento attivato con successo',
      activateError: 'Errore nell\'attivazione dell\'evento',
      deactivateSuccess: 'Evento disattivato con successo',
      deactivateError: 'Errore nella disattivazione dell\'evento',
      completeSuccess: 'Evento completato con successo',
      completeError: 'Errore nel completamento dell\'evento',
      showRankingBtn: 'Mostra classifica al pubblico',
      hideRankingBtn: 'Nascondi classifica al pubblico',
      rankingHidden: 'Classifica nascosta al pubblico',
      rankingVisible: 'Classifica visibile al pubblico',
      toggleBlindVoteError: 'Errore nel cambio visibilità classifica',
      live: {
        title: 'Dashboard live',
        loading: 'Caricamento...',
        errorLoad: 'Errore nel caricamento dei dati',
        errorToggle: 'Errore nel cambio visibilità',
        errorMarkPlayed: 'Errore nel marcare il brano',
        eventNotFound: 'Evento non trovato',
        backToEvents: 'Torna agli eventi',
        totalVotes: 'Voti totali',
        uniqueVoters: 'Votanti unici',
        songsPlayed: 'Brani suonati',
        noVotesYet: 'Ancora nessun voto',
        noVotes: 'Ancora nessun voto',
        rankingHidden: 'Classifica nascosta',
        rankingVisible: 'Classifica visibile',
        markPlayed: 'Segna come suonato',
        unmarkPlayed: 'Togli segno suonato',
        autoRefresh: 'Aggiornamento automatico',
        openLive: 'Apri live',
      },
      songs: {
        title: 'Brani dell\'evento',
        subtitle: 'Gestisci i brani disponibili per il voto',
        addSong: 'Aggiungi brano',
        searchExisting: 'Cerca brano esistente',
        searchPlaceholder: 'Cerca per titolo o artista...',
        noResults: 'Nessun brano trovato',
        or: 'OPPURE',
        songTitle: 'Titolo',
        titlePlaceholder: 'Es: Bohemian Rhapsody',
        artist: 'Artista',
        artistPlaceholder: 'Es: Queen',
        duration: 'Durata',
        durationPlaceholder: 'Es: 5:55',
        year: 'Anno',
        yearPlaceholder: 'Es: 2020',
        add: 'Aggiungi',
        adding: 'Aggiunta...',
        remove: 'Rimuovi',
        noSongs: 'Nessun brano per questo evento',
        addSuccess: 'Brano aggiunto con successo',
        addError: 'Errore nell\'aggiunta del brano',
        createSuccess: 'Brano creato e aggiunto con successo',
        createError: 'Errore nella creazione del brano',
        removeSuccess: 'Brano rimosso con successo',
        removeError: 'Errore nella rimozione del brano',
        errorLoad: 'Errore nel caricamento dei brani',
        copyFromEvent: 'Copia da un altro evento',
        copyModal: {
          title: 'Copia elenco brani',
          description: 'Seleziona un evento per copiarne l\'elenco brani in questo evento.',
          noEvents: 'Nessun altro evento disponibile',
        },
        copySuccess: 'Brani copiati con successo',
        copySuccessCount: 'brano/i aggiunti',
        copySkipped: 'già presente',
        copyNoSongs: 'L\'evento selezionato non contiene brani',
        copyAllAlreadyAdded: 'Tutti i brani di questo evento sono già presenti',
        copyError: 'Errore nella copia dei brani',
      },
    },
    songs: {
      title: 'Biblioteca brani',
      subtitle: 'Gestisci il repertorio della band',
      songsList: 'Elenco brani',
      noSongs: 'Nessun brano ancora',
      addSong: 'Aggiungi brano',
      add: 'Aggiungi',
      adding: 'Aggiunta...',
      edit: 'Modifica',
      editing: 'Modifica...',
      cancel: 'Annulla',
      confirm: 'Conferma',
      confirmDeleteTitle: 'Elimina brano',
      confirmDelete: 'Sei sicuro di voler eliminare "{{title}}" di {{artist}}?',
      songTitle: 'Titolo',
      titlePlaceholder: 'Es: Bohemian Rhapsody',
      artist: 'Artista',
      artistPlaceholder: 'Es: Queen',
      duration: 'Durata',
      durationPlaceholder: 'Es: 5:55',
      durationFormat: 'Formato: MM:SS (es: 3:45)',
      year: 'Anno',
      yearPlaceholder: 'Es: 2020',
      addSuccess: 'Brano aggiunto con successo',
      addError: 'Errore nell\'aggiunta del brano',
      updateSuccess: 'Brano aggiornato con successo',
      updateError: 'Errore nell\'aggiornamento del brano',
      deleteSuccess: 'Brano eliminato con successo',
      deleteError: 'Errore nell\'eliminazione del brano',
      errorLoad: 'Errore nel caricamento dei brani',
      delete: 'Elimina',
    },
    settings: {
      title: 'Impostazioni band',
      subtitle: 'Gestisci le informazioni della band',
      bandName: 'Nome band',
      bandNamePlaceholder: 'Nome della tua band',
      logoUrl: 'URL logo',
      logoUrlPlaceholder: 'https://example.com/logo.png',
      logoPreview: 'Anteprima logo',
      save: 'Salva',
      saving: 'Salvataggio...',
      successMessage: 'Impostazioni salvate con successo',
      errorLoad: 'Errore nel caricamento delle impostazioni',
      errorSave: 'Errore nel salvataggio delle impostazioni',
    },
    members: {
      title: 'Membri della band',
      subtitle: 'Gestisci i membri della band',
      membersList: 'Elenco membri',
      noMembers: 'Nessun membro ancora',
      inviteMember: 'Invita membro',
      invite: 'Invita',
      inviting: 'Invito in corso...',
      cancel: 'Annulla',
      confirm: 'Conferma',
      confirmRemoveTitle: 'Rimuovi membro',
      confirmToggleOwnerTitle: 'Cambia stato proprietario',
      email: 'Email',
      emailPlaceholder: 'membro@example.com',
      password: 'Password',
      passwordPlaceholder: 'Minimo 8 caratteri',
      firstName: 'Nome',
      firstNamePlaceholder: 'Nome (opzionale)',
      lastName: 'Cognome',
      lastNamePlaceholder: 'Cognome (opzionale)',
      owner: 'Proprietario',
      invitedBy: 'Invitato da',
      remove: 'Rimuovi',
      confirmRemove: 'Sei sicuro di voler rimuovere {{email}} dalla band?',
      inviteSuccess: 'Membro invitato con successo',
      inviteError: 'Errore nell\'invito del membro',
      removeSuccess: 'Membro rimosso con successo',
      removeError: 'Errore nella rimozione del membro',
      errorLoad: 'Errore nel caricamento dei membri',
      promote: 'Promuovi a proprietario',
      demote: 'Retrocedi',
      confirmToggleOwner: 'Sei sicuro di voler {{action}} questo membro?',
      promoteSuccess: 'Membro promosso a proprietario con successo',
      demoteSuccess: 'Membro retrocesso con successo',
      toggleOwnerError: 'Errore nel cambio stato del membro',
    },
    venues: {
      title: 'Locali da concerto',
      subtitle: 'Gestisci i locali dove suonate',
      venuesList: 'Elenco locali',
      noVenues: 'Nessun locale ancora',
      addVenue: 'Aggiungi locale',
      add: 'Aggiungi',
      adding: 'Aggiunta...',
      edit: 'Modifica',
      editing: 'Modifica...',
      cancel: 'Annulla',
      confirm: 'Conferma',
      confirmDeleteTitle: 'Elimina locale',
      confirmDelete: 'Sei sicuro di voler eliminare il locale "{{name}}"?',
      name: 'Nome locale',
      namePlaceholder: 'Es: Il Zenith',
      address: 'Indirizzo',
      addressPlaceholder: 'Es: 211 Avenue Jean Jaurès',
      city: 'Città',
      cityPlaceholder: 'Es: Parigi',
      country: 'Paese',
      countryPlaceholder: 'Es: Italia',
      googleMapsUrl: 'Link Google Maps',
      googleMapsUrlPlaceholder: 'Es: https://maps.google.com/...',
      generateMapsUrl: 'Genera link Google Maps',
      generateMapsUrlError: 'Inserisci almeno il nome del locale o la città per generare il link.',
      viewOnGoogleMaps: 'Vedi su Google Maps',
      addSuccess: 'Locale aggiunto con successo',
      addError: 'Errore nell\'aggiunta del locale',
      updateSuccess: 'Locale aggiornato con successo',
      updateError: 'Errore nell\'aggiornamento del locale',
      deleteSuccess: 'Locale eliminato con successo',
      deleteError: 'Errore nell\'eliminazione del locale',
      errorLoad: 'Errore nel caricamento dei locali',
    },
  },
  notFound: {
    title: 'Pagina non trovata',
    subtitle: 'Questa pagina non esiste',
    description: 'La pagina che cerchi potrebbe essere stata spostata o eliminata.',
    quickLinks: 'Link rapidi',
    goHome: 'Torna alla home',
    goToLogin: 'Vai al login',
    helpText: 'Se pensi sia un errore, contatta il supporto.',
  },
}
